import { colorMetadata } from "../../colorMetadata";
// colorStoreFunctions.js
///////////
// Actions
export const addColor = (color) => ({
  type: "ADD_COLOR",
  payload: colorMetadata(color)
});

export const addMoreColors = (colors) => ({
  type: "ADD_MORE_COLORS",
  payload: Array.isArray(colors) ? colors.map(colorMetadata) : colors
});

export const replaceStoreWithColor = (color) => ({
  type: "REPLACE_COLOR",
  payload: colorMetadata(color)
});

export const replaceStoreWithMoreColors = (colors) => ({
  type: "REPLACE_MORE_COLORS",
  payload: Array.isArray(colors) ? colors.map(colorMetadata) : colors
});

export const updateColor = (modifiedColor) => ({
  type: "UPDATE_COLOR",
  payload: colorMetadata(modifiedColor)
});

export const deleteColor = (colorId) => ({
  type: "DELETE_COLOR",
  payload: colorId
});

export const selectColor = (colorId) => ({
  type: "SELECT_COLOR",
  payload: colorId
});

export const setColorLoading = (loading) => ({
  type: "SET_COLOR_LOADING",
  payload: loading
});

///////////
// Initialstate
const initialState = {
  colors: [],
  selectedColor: "0"
};

///////////
// Reducers
export const colorReducer = (state = initialState.colors, action) => {
  if (["ADD_COLOR", "REPLACE_COLOR", "UPDATE_COLOR"].includes(action.type)) {
    action = { ...action, payload: colorMetadata(action.payload) };
  } else if (["ADD_MORE_COLORS", "REPLACE_MORE_COLORS"].includes(action.type) && Array.isArray(action.payload)) {
    action = { ...action, payload: action.payload.map(colorMetadata) };
  }
  switch (action.type) {
    case "ADD_COLOR": {
      const colorId = String(action.payload.colorId);

      const exists = state.some((obj) => String(obj.colorId) === colorId);

      if (exists) {
        return state.map((obj) =>
          String(obj.colorId) === colorId ? action.payload : obj
        );
      }

      return [...state, action.payload];
    }

    case "ADD_MORE_COLORS": {
      if (!Array.isArray(action.payload)) return state;

      const merged = [...state];

      action.payload.forEach((color) => {
        const colorId = String(color.colorId);
        const index = merged.findIndex(
          (existingColor) => String(existingColor.colorId) === colorId
        );

        if (index >= 0) {
          merged[index] = color;
        } else {
          merged.push(color);
        }
      });

      return merged;
    }

    case "REPLACE_COLOR":
      return [action.payload];

    case "REPLACE_MORE_COLORS":
      return Array.isArray(action.payload) ? action.payload : state;

    case "UPDATE_COLOR":
      return state.map((obj) =>
        String(obj.colorId) === String(action.payload.colorId)
          ? action.payload
          : obj
      );

    case "DELETE_COLOR":
      return state.filter(
        (obj) => String(obj.colorId) !== String(action.payload)
      );

    default:
      return state;
  }
};

export const selectedColorReducer = (
  state = initialState.selectedColor,
  action
) => {
  switch (action.type) {
    case "SELECT_COLOR":
      return action.payload;
    default:
      return state;
  }
};
